@import '../../utils/chrome-layout.css';
@import '../../utils/focus-ring.css';
@import '../../utils/interaction-fill.css';

:host {
  display: block;
  min-width: 0;
  background: var(--color-background-primary);
  color: var(--color-foreground-tertiary);
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.mobile-bar-nav {
  justify-content: space-between;
  min-width: 0;
  padding-block-end: max(var(--ds-chrome-padding), env(safe-area-inset-bottom));
  border-top: var(--dimension-stroke-width-012) solid var(--color-border-tertiary);
  background: var(--color-background-primary);
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.mobile-bar-nav__group {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-100);
}

.mobile-bar-nav__item {
  appearance: none;
  flex: 0 0 var(--dimension-size-500);
  width: var(--dimension-size-500);
  height: var(--dimension-size-500);
  padding: var(--dimension-space-100);
  border: 0;
  border-radius: var(--dimension-radius-025);
  background: transparent;
  color: inherit;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: default;
}

.mobile-bar-nav__item--selected {
  color: var(--color-foreground-primary);
}

/*
 * Safari can retain its native :active state after a direct touch. On coarse
 * touch-only pointers, the component-owned class provides one deterministic
 * press frame and clears it after release/cancel.
 */
@media (hover: none) and (pointer: coarse) {
  .mobile-bar-nav__item.ds-interaction-fill:active:not(:disabled)::after {
    background: transparent;
  }

  .mobile-bar-nav__item--pressed.ds-interaction-fill::after,
  .mobile-bar-nav__item--pressed.ds-interaction-fill:active:not(:disabled)::after {
    background: var(--ds-interaction-pressed);
  }
}

.mobile-bar-nav__divider {
  flex: 0 0 var(--dimension-stroke-width-012);
  width: var(--dimension-stroke-width-012);
  height: var(--dimension-iconography-lg);
  background: var(--color-border-tertiary);
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}

.mobile-bar-nav__icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--dimension-iconography-lg);
  height: var(--dimension-iconography-lg);
}

.mobile-bar-nav__dot {
  position: absolute;
  inset-block-start: calc(var(--dimension-space-025) * -1);
  inset-inline-end: calc(var(--dimension-space-025) * -1);
}
